import { render } from "./MainMenuView.vue?vue&type=template&id=645ddc20&scoped=true&ts=true"
import script from "./MainMenuView.vue?vue&type=script&lang=ts"
export * from "./MainMenuView.vue?vue&type=script&lang=ts"

import "./MainMenuView.vue?vue&type=style&index=0&id=645ddc20&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645ddc20"]])

export default __exports__